module.exports = function getResource(label) {
    const resources = { qty: 'Quantité', loved: 'Favoris', moveToLoves: 'Move to Loves', getItSooner: 'Get It Sooner' };

    return resources[label];
};
